import { MONTH_ABBRS, WEEKDAY_ABBRS } from '../constants';

import type { AbsoluteOpeningHours, OpeningHours, RecurringOpeningHours } from '../types';

function isOpeningHours(value: unknown): value is OpeningHours {
  return (
    typeof value === 'object' && value !== null && 'from' in value && typeof value.from === 'string'
  );
}

export function isRecurringOpeningHours(value: unknown): value is RecurringOpeningHours {
  return (
    isOpeningHours(value) &&
    Object.values(WEEKDAY_ABBRS).some((weekdayName) => value.from === weekdayName)
  );
}

export function isAbsoluteOpeningHours(value: unknown): value is AbsoluteOpeningHours {
  return (
    isOpeningHours(value) &&
    Object.values(MONTH_ABBRS).some((monthName) => value.from.startsWith(monthName))
  );
}
